import { createContext, useContext, useReducer } from 'react';
import { DashboardState, DashboardReducer, ACTION_TYPES } from './dashboard-reducer';
import { IDashboardResponse } from '../../../../model/scp/dashboard/dashboard-response';

const DashboardContext = createContext<DashboardState | undefined>(undefined);
const DashboardDispatchContext = createContext({} as any);

const DashboardProvider = ({ children }: { children: React.ReactNode }) => {
    const currentYear = new Date().getFullYear();

    const initialState: DashboardState = {
        dashboardData: {
            purchaseStatistics: {
                totalPurchases: 0,
                inProgressPurchases: 0,
                completedPurchases: 0,
                cancelledPurchases: 0,
                currentYearPurchases: 0,
                previousYearPurchases: 0,
                growthPercentage: 0
            },
            contractStatistics: {
                totalContracts: 0,
                activeContracts: 0,
                expiredContracts: 0,
                expiringSoonContracts: 0,
                currentYearContracts: 0,
                previousYearContracts: 0,
                growthPercentage: 0
            },
            priceRegistrationStatistics: {
                totalPriceRegistrations: 0,
                activePriceRegistrations: 0,
                expiredPriceRegistrations: 0,
                currentYearPriceRegistrations: 0
            },
            timeline: [],
            modalityDistribution: [],
            situationDistribution: [],
            contractTypeDistribution: []
        } as IDashboardResponse,
        selectedYear: currentYear,
        loading: false,
    };

    const [state, dispatch] = useReducer(DashboardReducer, initialState);

    return (
        <DashboardContext.Provider value={state}>
            <DashboardDispatchContext.Provider value={dispatch}>
                {children}
            </DashboardDispatchContext.Provider>
        </DashboardContext.Provider>
    );
}

const useDashboardState = () => {
    const context = useContext(DashboardContext);
    if (context === undefined) {
        throw new Error('useDashboardState must be used within a DashboardProvider');
    }
    return context;
}

const useDashboardDispatch = () => {
    const context = useContext(DashboardDispatchContext);
    if (context === undefined) {
        throw new Error('useDashboardDispatch must be used within a DashboardProvider');
    }
    return context;
}

export { DashboardProvider, useDashboardDispatch, useDashboardState, ACTION_TYPES };
